import { Box, Heading, Text, Link as ChakraLink } from '@chakra-ui/react';
import React  from 'react';
import { Link } from 'react-router-dom';


const Migrate: React.FC = () => {
    return (
        <Box
            minHeight="100vh"
            width="100vw"
            backgroundImage="url('/images/forest.jpg')"
            backgroundSize="cover"
            backgroundPosition="center"
            display="flex"
            justifyContent="center"
            alignItems="center"
        >
            <Box
                bg="white"
                padding="5"
                margin="8"
                borderRadius="md"
                boxShadow="lg"
                textAlign="center"
                width="2xl"
            >
                <Heading
                    padding="3"
                    as="h2"
                    size="lg"
                >
                    Migracja
                </Heading>
                <Text
                    mt={8}
                >
                    Nie posiadałeś konta w starym systemie?{" "}
                    <ChakraLink as={Link} to="/login"
                                color="brand.500"
                                fontWeight="bold"
                    >
                        Stwórz konto!
                    </ChakraLink>
                </Text>
            </Box>
        </Box>
    );
};

export default Migrate;
